import './navExpenseHub.css'; 

export default function NavExpenseHub() {
    return(
        <div>
            <svg width="24.786" height="21.687" viewBox="0 0 24.786 21.687">
                <path id="Icon_fa-solid-folder" data-name="Icon fa-solid-folder" d="M3.1,23.937H21.687a3.1,3.1,0,0,0,3.1-3.1V8.446a3.1,3.1,0,0,0-3.1-3.1H13.942a1.538,1.538,0,0,1-1.239-.62l-.929-1.239A3.1,3.1,0,0,0,9.295,2.25H3.1A3.1,3.1,0,0,0,0,5.348V20.839A3.1,3.1,0,0,0,3.1,23.937Z" transform="translate(0 -2.25)" fill="#72bf72"/>
            </svg>
        </div>
    )
}